// Phân tích User-Agent của lượt click (dùng chung cho click Shopee và Lazada)

export const badgeStyleMap = {
  green: 'border-green-200 bg-green-50 text-green-700',
  purple: 'border-purple-200 bg-purple-50 text-purple-700',
  blue: 'border-blue-200 bg-blue-50 text-blue-700',
  indigo: 'border-indigo-200 bg-indigo-50 text-indigo-700',
  orange: 'border-orange-200 bg-orange-50 text-orange-700',
  rose: 'border-rose-200 bg-rose-50 text-rose-700',
  gray: 'border-gray-200 bg-gray-50 text-gray-700'
};

const deviceVariantOverride = {
  iPhone: 'blue',
  'Điện thoại Android': 'orange',
  'Điện thoại': 'orange',
  'Điện thoại Windows': 'orange',
  'Máy tính': 'gray',
  'Máy tính bảng': 'gray',
  Chromebook: 'gray',
  'PC Windows': 'gray',
  Mac: 'gray',
  'PC Linux': 'gray',
  'Phím tắt': 'green'
};

export const parseClientFromUA = (uaRaw, isPwa) => {
  try {
    if (isPwa) return { label: 'Phím tắt', variant: 'green' };
    const ua = String(uaRaw || '').toLowerCase();
    if (!ua) return { label: 'Unknown', variant: 'gray' };
    // Webviews / Apps
    if (/(fbav|fban|facebook)/.test(ua)) return { label: 'Facebook WebView', variant: 'purple' };
    if (/instagram/.test(ua)) return { label: 'Instagram WebView', variant: 'purple' };
    if (/(zalo|zalobrowser)/.test(ua)) return { label: 'Zalo WebView', variant: 'purple' };
    if (/tiktok/.test(ua)) return { label: 'TikTok WebView', variant: 'purple' };
    if (/micromessenger|wechat/.test(ua)) return { label: 'WeChat WebView', variant: 'purple' };
    if (/line/.test(ua)) return { label: 'LINE WebView', variant: 'purple' };
    if (/kakaotalk/.test(ua)) return { label: 'KakaoTalk WebView', variant: 'purple' };
    if (/messenger/.test(ua)) return { label: 'Messenger WebView', variant: 'purple' };
    if (/twitter/.test(ua)) return { label: 'Twitter WebView', variant: 'purple' };
    // Browsers (iOS first)
    if (/crios/.test(ua)) return { label: 'Chrome iOS', variant: 'blue' };
    if (/fxios/.test(ua)) return { label: 'Firefox iOS', variant: 'orange' };
    if (/edgios/.test(ua)) return { label: 'Edge iOS', variant: 'indigo' };
    if ((/iphone|ipad|ipod/.test(ua)) && /safari/.test(ua) && !/crios|fxios|edgios/.test(ua)) return { label: 'Safari iOS', variant: 'gray' };
    // Android/Desktop
    if (/samsungbrowser/.test(ua)) return { label: 'Samsung Internet', variant: 'blue' };
    if (/edg\//.test(ua)) return { label: 'Microsoft Edge', variant: 'indigo' };
    if (/opr\//.test(ua) || /opera/.test(ua)) return { label: 'Opera', variant: 'rose' };
    if (/firefox/.test(ua)) return { label: 'Firefox', variant: 'orange' };
    if (/chrome/.test(ua) && !/edg\//.test(ua) && !/opr\//.test(ua)) return { label: 'Chrome', variant: 'blue' };
    if (/safari/.test(ua)) return { label: 'Safari', variant: 'gray' };
    return { label: 'Unknown', variant: 'gray' };
  } catch (_) {
    return { label: 'Unknown', variant: 'gray' };
  }
};

export const parseDeviceDetails = (uaRaw, isPwa) => {
  const unknown = { deviceType: 'Không rõ', deviceName: '', os: '', variant: 'gray' };
  try {
    const ua = String(uaRaw || '');
    if (!ua) return unknown;

    const lowerUA = ua.toLowerCase();
    const contains = (regex) => regex.test(lowerUA);
    const result = { ...unknown };

    const setDeviceType = (type, variant) => {
      result.deviceType = type;
      if (variant) result.variant = variant;
    };

    if (contains(/ipad|tablet|sm-\w+|tab|xoom|kf[a-z0-9]+|silk/)) {
      setDeviceType('Máy tính bảng', 'purple');
    } else if (contains(/iphone|ipod|android|blackberry|bb10|windows phone|opera mini|mobile|ucbrowser/)) {
      setDeviceType('Điện thoại', 'blue');
    } else if (contains(/windows nt|macintosh|cros|linux|x11/)) {
      setDeviceType('Máy tính', 'gray');
    }

    if (contains(/iphone/)) {
      result.deviceType = 'iPhone';
      result.variant = 'blue';
      result.deviceName = 'iPhone';
      result.os = 'iOS';
    } else if (contains(/ipad/)) {
      setDeviceType('Máy tính bảng', 'purple');
      result.deviceName = 'iPad';
      result.os = 'iPadOS';
    } else if (contains(/ipod/)) {
      result.deviceType = 'iPhone';
      result.variant = 'blue';
      result.deviceName = 'iPod';
      result.os = 'iOS';
    } else if (contains(/android/)) {
      result.deviceType = 'Điện thoại Android';
      result.variant = 'orange';
      result.os = 'Android';

      const brandMap = [
        { regex: /samsung|sm-|gt-|sch-/, name: 'Samsung' },
        { regex: /xiaomi|redmi|mi |poco/, name: 'Xiaomi/POCO' },
        { regex: /oppo/, name: 'OPPO' },
        { regex: /vivo/, name: 'Vivo' },
        { regex: /oneplus/, name: 'OnePlus' },
        { regex: /pixel/, name: 'Google Pixel' },
        { regex: /huawei/, name: 'Huawei' },
        { regex: /honor/, name: 'Honor' },
        { regex: /realme/, name: 'Realme' },
        { regex: /motorola|moto/, name: 'Motorola' },
        { regex: /nokia/, name: 'Nokia' }
      ];
      const matchedBrand = brandMap.find((brand) => brand.regex.test(lowerUA));
      if (matchedBrand) result.deviceName = matchedBrand.name;
    } else if (contains(/windows phone/)) {
      result.deviceType = 'Điện thoại Windows';
      result.variant = 'indigo';
      result.deviceName = 'Windows Phone';
      result.os = 'Windows Phone';
    } else if (contains(/macintosh/)) {
      setDeviceType('Máy tính', 'gray');
      result.deviceName = 'Mac';
      result.os = 'macOS';
    } else if (contains(/windows nt/)) {
      setDeviceType('Máy tính', 'indigo');
      result.deviceName = 'PC Windows';
      result.os = 'Windows';
    } else if (contains(/cros/)) {
      setDeviceType('Máy tính', 'green');
      result.deviceName = 'Chromebook';
      result.os = 'ChromeOS';
    } else if (contains(/linux/)) {
      setDeviceType('Máy tính', 'gray');
      result.deviceName = 'PC Linux';
      result.os = 'Linux';
    } else if (contains(/x11/)) {
      setDeviceType('Máy tính', 'gray');
      result.deviceName = 'Máy tính';
      result.os = '';
    }

    if (!result.deviceName && result.deviceType && result.deviceType.includes('Điện thoại')) {
      result.deviceName = result.deviceType;
    }

    if (deviceVariantOverride[result.deviceType]) {
      result.variant = deviceVariantOverride[result.deviceType];
    }

    if (isPwa) {
      if (result.deviceType === 'Không rõ') {
        result.deviceType = 'Phím tắt';
        result.deviceName = 'Phím tắt';
      }
      result.variant = deviceVariantOverride['Phím tắt'] || 'green';
    }

    return result;
  } catch (error) {
    console.error('Device parsing error:', error, 'ua:', uaRaw);
    return unknown;
  }
};
